<script lang="ts">
	import type { ISbStoryData, SbBlokData } from '@storyblok/js';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import Blok from '../blok.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			slot_1: SbBlokData[];
			slot_2: SbBlokData[];
			slot_3: SbBlokData[];
			slot_4: string;
			bg_color: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

{#snippet slot1()}
	{#if content.slot_1?.length > 0}
		<div class="aspect-3/4 overflow-hidden rounded-lg">
			<Blok content={content.slot_1[0]} />
		</div>
	{/if}
{/snippet}

<section
	use:editable={content}
	class="py-16 lg:py-[120px]"
	style="background-color: {content.bg_color || 'transparent'};"
>
	<PageGrid16 gridClass="flex flex-col max-lg:gap-y-9" margin>
		<h1
			class="col-span-full text-[44px]/[108%] tracking-[-.44px] text-white lg:col-start-2 lg:col-end-11 lg:text-[64px]/[110%] lg:tracking-[-.64px]"
		>
			{content.headline}
		</h1>

		<div
			class="col-span-full max-lg:flex max-lg:flex-col max-lg:gap-y-9 lg:col-start-2 lg:col-end-7"
		>
			<div class="lg:hidden">
				{@render slot1()}
			</div>
			{#if content.slot_2?.length > 0}
				<div class="lg:mt-18">
					<Blok content={content.slot_2[0]} />
				</div>
			{/if}
			{#if content.slot_3?.length > 0}
				<div class="aspect-square overflow-hidden rounded-lg lg:mt-[164px]">
					<Blok content={content.slot_3[0]} />
				</div>
			{/if}
		</div>

		<div class="col-span-full lg:col-start-9 lg:col-end-[16]">
			<div class="mt-10 max-lg:hidden">
				{@render slot1()}
			</div>
			{#if content.slot_4?.length > 0}
				<p
					class="text-[16px]/[150%] tracking-[-.16px] text-white lg:mt-[108px] lg:text-[20px]/[140%] lg:tracking-[-.2px]"
				>
					{content.slot_4}
				</p>
			{/if}
		</div>
	</PageGrid16>
</section>
